import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/core/app.state';
import { ICatalog, IGeneralRules, SaveCustomData } from '../../models/catalogs.models';
import { ILocation } from 'src/app/features/customers/models/customers.models';
import { IProduct, IVariant } from 'src/app/features/produits/models/products.models';
import { IBrand } from 'src/app/features/brands/models/brands.models';
import { ICategory } from 'src/app/features/categories/models/categories.models';
import { ITag } from 'src/app/features/tags/models/tags.models';
import { AddCatalog, DeleteCatalog, DeleteCatalogSuccess, GetCatalogById, GetCatalogByIdSuccess, GetCatalogProducts, GetCatalogProductsSuccess, UpdateCatalog, UpdateCatalogSuccess } from '../../store/catalogs.actions';
import { Subscription, tap } from 'rxjs';
import { SetCurrentElementId } from 'src/app/shared/store/shared.actions';
import { MatStepper } from '@angular/material/stepper';
import { EditBasicCatalogsInfosComponent } from '../edit-basic-catalogs-infos/edit-basic-catalogs-infos.component';
import { MatDialog } from '@angular/material/dialog';
import { EditGeneralRulesComponent } from '../edit-general-rules/edit-general-rules.component';
import { ConfirmationPopUpComponent } from 'src/app/shared/confirmation-pop-up/confirmation-pop-up.component';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { customValidator } from 'src/app/shared/validators/fields-validators';
import { HasPermissionContext } from 'src/app/shared/has-permission.directive';

@Component({
  selector: 'app-details-catalog',
  templateUrl: './details-catalog.component.html',
  styleUrls: ['./details-catalog.component.scss']
})
export class DetailsCatalogComponent implements OnInit {

  @ViewChild('stepper') stepper: MatStepper | undefined;
  form!: FormGroup;
  generalRulesform!: FormGroup;
  currentForm: string = "basicForm";
  selectedProducts: IProduct[] = [];
  selectedLocations: ILocation[] = [];
  catalogId!: number;
  catalog: ICatalog | undefined = undefined;
  disableDate!: boolean;
  locations: ILocation[] = [];
  imageCatalog!: string;
  defaultVariantAvatar: string = '../../../../../assets/images/uoload-image.jpeg'
  generalRules!: IGeneralRules;
  currentCustomDiscount!: number
  private subscriptions: Subscription[] = [];
  baseUrl = environment.BASE_URL_API;
  selectedProductsLoaded: boolean = false;
  constructor(
    private fb: FormBuilder,
    private store: Store<AppState>,
    private dialog: MatDialog,
    private actions$: Actions,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private translateService: TranslateService,
  ) { }


  ngOnInit(): void {
    this.initializeForm();
    this.initializeGeneralRulesForm();
    this.onToggleChange();
    this.catalogId = +this.activatedRoute.snapshot.paramMap.get('id')!;
    if (this.catalogId) {
      this.store.dispatch(SetCurrentElementId({ currentElementId: this.catalogId }))
      this.store.dispatch(GetCatalogById({ id: this.catalogId }))
    }
    const sub0 = this.actions$.pipe(
        ofType(GetCatalogProductsSuccess),
        tap((action) => {
          this.selectedProductsLoaded = true;
          this.selectedProducts = action.products.map((product: IProduct) =>{
              return {
            ...product
            }
        });
        })).subscribe();

    const sub1 = this.actions$.pipe(
      ofType(GetCatalogByIdSuccess, UpdateCatalogSuccess),
      tap((action) => {
        this.catalog = action.catalog
        if(this.catalog)
        {
          this.selectedLocations = this.catalog.locations!.map((location: ILocation) =>{
            return {
              ...location
            }
          });
          let uniqueProducts: (IProduct | IVariant)[] = []
          this.selectedProducts.map((product) => {
            const productDetail = product.variants?.length ? product.variants : [product];
            uniqueProducts = [...uniqueProducts, ...productDetail]
          })
          this.disableDate = !!this.catalog.end_date
          this.imageCatalog = this.catalog.image!;
          this.initializeForm();
          if(!!this.catalog.end_date){
            setTimeout(() => {
              this.form.get('end_date')?.enable()
            }, 0);
          }
          this.initializeGeneralRulesForm(this.catalog);
          this.generalRules = this.generalRulesform.value
        }
      })).subscribe();


    const sub2 = this.actions$.pipe(
        ofType(DeleteCatalogSuccess),
        tap(() => {
        this.router.navigate(['catalogs'], {
          queryParamsHandling: 'preserve'
        });
      })).subscribe();

      this.subscriptions.push(sub0, sub1, sub2)


  }

  onImageError(event: Event): void {
    const target = event.target as HTMLImageElement;
    target.src = this.defaultVariantAvatar;
  }

  private initializeGeneralRulesForm(generalRules?: IGeneralRules): void {
    this.generalRulesform = this.fb.group({
      general_discount: new FormControl(generalRules?.general_discount ?? 0, [Validators.required]),
      increment: new FormControl(generalRules?.increment ?? 1, [Validators.required]),
      max_qte: new FormControl(generalRules?.max_qte ?? null),
      min_qte: new FormControl(generalRules?.min_qte ?? 1, [Validators.required]),
      can_be_sold_out_of_stock: new FormControl(generalRules?.can_be_sold_out_of_stock ?? false, [Validators.required]),
      show_stock: new FormControl(generalRules?.show_stock ?? true, [Validators.required]),
    }, { validators: customValidator(this.translateService) });
  }

  initializeForm(): void {
    this.form = this.fb.group({
      name: new FormControl(this.catalog?.name ?? '', Validators.required),
      start_date: new FormControl(this.catalog?.start_date ?? '', [this.validateStartDate.bind(this)]),
      end_date: new FormControl(this.catalog?.end_date ?? '', [this.validateEndDate.bind(this)]),
      status: new FormControl(this.catalog?.status ?? ''),
    });
  }

  validateStartDate(control: any) {
    if (!control.value) {
      return null;
    }

    const today = new Date();
    const startDate = new Date(control.value);

    today.setHours(0, 0, 0, 0);
    startDate.setHours(0, 0, 0, 0);

    if (this.catalog && this.catalog.start_date) {
      const existingStartDate = new Date(this.catalog.start_date);
      existingStartDate.setHours(0, 0, 0, 0);

      if (startDate.getTime() === existingStartDate.getTime()) {

        return null;
      }
    }

    return startDate >= today ? null : { startDateInvalid: true };
  }

  validateEndDate(control: any) {
    if (!this.form) {
      return null;
    }
    if (!control.value) {
      return null;
    }
    const startDate = new Date(this.form.get('start_date')?.value);
    const endDate = new Date(control.value);
    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0, 0, 0);
    return endDate >= startDate ? null : { endDateInvalid: true };
  }

  onToggleChange(){
    const endDateControle = this.form.get('end_date');
    if(!this.disableDate){
      endDateControle?.reset()
      endDateControle?.disable()
    } else {
      endDateControle?.enable()
    }
  }

  cancel(submitType: string) {
    this.currentForm = 'basicForm';
  }

  onSaveProducts(data: {selectedProducts: IProduct[], missingPricing: boolean}){
    this.selectedProducts = data.selectedProducts;

    this.currentForm = data.missingPricing ? 'customProducts' : 'basicForm';

    if(!data.missingPricing) {
      this.save("products");
    }
  }

  onSaveLocations(selectedLocations: ILocation[]){
    this.selectedLocations = selectedLocations;
    this.currentForm = 'basicForm';
    this.save("locations");
  }

  sumDiscount(a: number): number {
    const A = +a / 100;
    const B = this.generalRulesform.get('general_discount')?.value ? +this.generalRulesform.get('general_discount')?.value / 100 : 0;
    return Math.ceil(
      parseFloat(
        ((A + B - (A * B)) * 100).toFixed(1)
      )
    )
  }

  onSaveCustomProducts(customeInfo: SaveCustomData){
    this.selectedProducts = customeInfo.customProducts;
    this.currentForm = 'basicForm';
    this.saveGeneraleRule(customeInfo.generalRules)
    this.save("products");
  }

  saveGeneraleRule(generalRules: IGeneralRules){
    this.initializeGeneralRulesForm(generalRules)
    this.generalRules = generalRules
    const generalDiscount = this.generalRulesform.get('general_discount')?.value
    this.currentCustomDiscount = generalDiscount ? generalDiscount : undefined
  }

  getCatalogImg(event: any) {
    let file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const dataUrl = e.target.result
        this.imageCatalog = dataUrl.split(',')[1]

      };
      reader.readAsDataURL(file);
    }
  }

  cancelImage(){
    this.imageCatalog = ''
  }

  goTo(form: string): boolean | void{
    if((form === 'customProducts' || form === 'insertProducts') && this.selectedProducts.length == 0){
      this.store.dispatch(GetCatalogProducts({ id: this.catalogId, page: 1, limit: 25 }))
    }
    this.currentForm = form
    const generalDiscount = this.generalRulesform.get('general_discount')?.value
    this.currentCustomDiscount = generalDiscount ? generalDiscount : undefined
  }

  editBasicInfo(){
    const dialogRef = this.dialog.open(EditBasicCatalogsInfosComponent, {
      data: {
        image: this.imageCatalog,
        name: this.form.get('name')?.value,
        status: this.form.get('status')?.value,
        start_date: this.form.get('start_date')?.value,
        end_date: this.form.get('end_date')?.value,
        isEdit: true,
      },
      disableClose: true,
    })
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.imageCatalog = result.image;
        this.form.get('name')?.setValue(result.name);
        this.form.get('status')?.setValue(result.status);
        this.form.get('start_date')?.setValue(result.start_date);
        this.form.get('end_date')?.setValue(result.end_date);

        this.save("basic_info");
      }
    });
  }

  editGeneralRules(){
    const dialogRef = this.dialog.open(EditGeneralRulesComponent, {
      data: {
        generalRules: this.generalRules,
        selectedProducts: this.selectedProducts,
        isEdit: true,
      },
      disableClose: true,
    })
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.generalRules = result.generalRules;
        this.selectedProducts = result.selectedProducts;
        this.initializeGeneralRulesForm(this.generalRules);

        this.save("general_rules");
      }
    });
  }

  removeLocation(location: ILocation) {
    this.selectedLocations = this.selectedLocations.filter(l => l.id !== location.id);
    this.save("locations")
  }

  removeLocationConfirmationDialog(location: ILocation): void | boolean {
    const dialogRef = this.dialog.open(ConfirmationPopUpComponent, {
      data: {
        icon: '../../../assets/icones/cancel_alert.svg',
        confirm_text: this.translateService.instant('common.remove'),
      },
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.removeLocation(location);
      }
    });
  }

  onGeneralDiscountChange(event: any){
    const input = event.target;
    const value = +input.value;
    if (value > 100) {
      input.value = 100;
      this.generalRulesform.get('general_discount')?.setValue(100);
      this.selectedProducts = this.selectedProducts.map((product: IProduct, index) => {
        if(product.variants && product.variants.length > 0 ){
          this.selectedProducts[index].variants = this.selectedProducts[index].variants?.map(variant => {
              return {
                ...variant,
                discount: 100,
            }
          })
          }
          return {
            ...product,
            discount: 100,
        }
      })
    }else {
      this.selectedProducts = this.selectedProducts.map((product: IProduct, index) => {
        if(product.variants && product.variants.length > 0 ){
          this.selectedProducts[index].variants = this.selectedProducts[index].variants?.map(variant => {
              return {
                ...variant,
                discount: event.target.value ? +event.target.value : undefined,
            }
          })
          }
          return {
            ...product,
            discount: event.target.value ? +event.target.value : undefined,
        }
      })
    }
    this.generalRules = this.generalRulesform.value
  }

  onGeneralIncrementChange(event: any){
    this.selectedProducts = this.selectedProducts.map((product: IProduct, index) => {
      if(product.variants && product.variants.length > 0 ){
        this.selectedProducts[index].variants = this.selectedProducts[index].variants?.map(variant => {
            return {
              ...variant,
              increment: event.target.value ? +event.target.value : undefined,
          }
        })
        }
        return {
          ...product,
          increment: event.target.value ? +event.target.value : undefined,
      }
    })
    this.generalRules = this.generalRulesform.value
  }

  onGeneralMinChange(event: any){
    const value = +event.target.value;
    const maxQte = this.generalRulesform.get('max_qte')?.value;

    if (maxQte && value > maxQte) {
      this.generalRulesform.get('min_qte')?.setValue(maxQte);
      this.selectedProducts = this.selectedProducts.map((product: IProduct, index) => {
        if(product.variants && product.variants.length > 0 ){
          this.selectedProducts[index].variants = this.selectedProducts[index].variants?.map(variant => {
              return {
                ...variant,
                min_qte: maxQte,
            }
          })
          }
          return {
            ...product,
            min_qte: maxQte,
        }
      })
    } else {
      this.selectedProducts = this.selectedProducts.map((product: IProduct, index) => {
        if(product.variants && product.variants.length > 0 ){
          this.selectedProducts[index].variants = this.selectedProducts[index].variants?.map(variant => {
              return {
                ...variant,
                min_qte: event.target.value ? +event.target.value : undefined,
            }
          })
          }
          return {
            ...product,
            min_qte: event.target.value ? +event.target.value : undefined,
        }
      })
    }
    this.generalRules = this.generalRulesform.value
  }

  onGeneralMaxChange(event: any){
    const value = +event.target.value;
    const minQte = this.generalRulesform.get('min_qte')?.value;
    if (value < minQte) {
      this.generalRulesform.get('max_qte')?.setValue(minQte);
      this.selectedProducts = this.selectedProducts.map((product: IProduct, index) => {
        if(product.variants && product.variants.length > 0 ){
          this.selectedProducts[index].variants = this.selectedProducts[index].variants?.map(variant => {
              return {
                ...variant,
              max_qte: minQte
            }
          })
          }
          return {
            ...product,
          max_qte: minQte
        }
      })
    } else {
      this.selectedProducts = this.selectedProducts.map((product: IProduct, index) => {
        if(product.variants && product.variants.length > 0 ){
          this.selectedProducts[index].variants = this.selectedProducts[index].variants?.map(variant => {
              return {
                ...variant,
                max_qte: event.target.value ? +event.target.value : undefined,
            }
          })
          }
          return {
            ...product,
            max_qte: event.target.value ? +event.target.value : undefined,
        }
      })
    }
    this.generalRules = this.generalRulesform.value
  }

  getUniqueBrands(): IBrand[] {
    const brandMap = new Map<number, IBrand>();
    this.selectedProducts.forEach(product => {
      if (product.brand && !brandMap.has(product.brand.id)) {
        if(product.brand.id) {
          brandMap.set(product.brand.id, product.brand);
        }
      }
    });

    return Array.from(brandMap.values());
  }

  getUniqueCategories(): ICategory[] {
    const categoryMap = new Map<number, ICategory>();

    this.selectedProducts.forEach(product => {
      product.categories?.forEach(category => {
        categoryMap.set(category.id, category);
      })
    });

    return Array.from(categoryMap.values());
  }

  getUniqueTags(): ITag[] {
    const tagMap = new Map<number, ITag>();
    this.selectedProducts.forEach(product => {
      if (product.tags) {
        product.tags.forEach(tag => {
          if (!tagMap.has(tag.id)) {
            tagMap.set(tag.id, tag);
          }
        });
      }
    });
    return Array.from(tagMap.values());
  }

  getProductsWithoutPricing() {
    return this.catalog?.count_products_without_price ?? 0;
  }

  submitPermission(): HasPermissionContext {
    return { module: 'catalog', action: this.catalogId ? 'edit' : 'create' };
  }

  save(module:string): boolean | void{
    let payload: any = {}
    let general_discount:any, increment:any, max_qte:any, min_qte:any, can_be_sold_out_of_stock = false, show_stock = true;
    switch (module) {
      case "general_rules":
        general_discount = this.generalRulesform.get('general_discount')?.value;
        increment = this.generalRulesform.get('increment')?.value;
        max_qte = this.generalRulesform.get('max_qte')?.value;
        min_qte = this.generalRulesform.get('min_qte')?.value;
        can_be_sold_out_of_stock = this.generalRulesform.get('can_be_sold_out_of_stock')?.value;
        show_stock = this.generalRulesform.get('show_stock')?.value;
        payload = {
          name: this.catalog?.name,
          general_discount: general_discount,
          increment: increment,
          max_qte: max_qte,
          min_qte: min_qte,
          can_be_sold_out_of_stock: can_be_sold_out_of_stock,
          show_stock: show_stock,
        }
        break;
      case "basic_info":
        if(!this.form.valid){
          this.form.markAllAsTouched();
          return false
        };
        const startDate = this.form.get('start_date')?.value;
        const endDate = this.form.get('end_date')?.value;
        payload = {
          name: this.form.get('name')?.value,
          image: this.imageCatalog ?? '',
          start_date: startDate ? startDate : null,
          end_date: endDate ? endDate : null,
          status: this.form.get('status')?.value,
        }
        break;
      case "locations":
        const locations_ids: number[] = [];
        this.selectedLocations.forEach(location => {
          locations_ids.push(location.id!)
        })
        payload = {
          name: this.catalog?.name,
          locations_ids: locations_ids,
        }
        break;
      case "products":
        general_discount = this.generalRulesform.get('general_discount')?.value;
        increment = this.generalRulesform.get('increment')?.value;
        max_qte = this.generalRulesform.get('max_qte')?.value;
        min_qte = this.generalRulesform.get('min_qte')?.value;
        can_be_sold_out_of_stock = this.generalRulesform.get('can_be_sold_out_of_stock')?.value;
        this.selectedProducts = this.selectedProducts.map((product: IProduct, index) => {
          return {
            ...product,
            discount: product.discount ?? general_discount,
            increment: product.increment ?? increment,
            min_qte: product.min_qte ?? min_qte,
            max_qte: product.max_qte ?? max_qte,
            can_be_sold_out_of_stock: product.can_be_sold_out_of_stock ?? can_be_sold_out_of_stock,
            variants: product.variants ? product.variants.map(variant => {
                    return {
                      ...variant,
                discount: variant.discount ??general_discount,
                increment: variant.increment ?? increment,
                min_qte: variant.min_qte ?? min_qte,
                max_qte: variant.max_qte ?? max_qte,
                can_be_sold_out_of_stock: variant.can_be_sold_out_of_stock ?? can_be_sold_out_of_stock,
              }
            }) : undefined
          }
        })
        payload = {
          name: this.catalog?.name,
          products: this.selectedProducts,
          general_discount: general_discount,
          increment: increment,
          max_qte: max_qte,
          min_qte: min_qte,
          can_be_sold_out_of_stock: can_be_sold_out_of_stock,
        }
        break;
    }

    if(this.catalogId){
      this.store.dispatch(UpdateCatalog({id:this.catalogId, catalog: payload}))
    }else{
      this.store.dispatch(AddCatalog({catalog: payload}))
    }
  }

  deleteCatalog() {
    const dialogRef = this.dialog.open(ConfirmationPopUpComponent, {
      data: {
        icon: '../../../assets/icones/cancel_alert.svg',
        confirm_text: this.translateService.instant('common.remove'),
      },
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.store.dispatch(DeleteCatalog({ id: this.catalogId }));
      }
    });
  }

  canceled(){
    this.router.navigate(['../'], {
      relativeTo: this.activatedRoute,
      queryParamsHandling: 'merge'
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub => sub.unsubscribe()))
  }


}
